export enum ActionTypeKeys {
    SET_DATE_FORMAT = 'SET_DATE_FORMAT',
    SET_DURATION_FORMAT = 'SET_DURATION_FORMAT',
    OPEN_MODAL = 'OPEN_MODAL',
    CLOSE_MODAL = 'CLOSE_MODAL',
    OPEN_DETAILS = 'OPEN_DETAILS',
    CLOSE_DETAILS = 'CLOSE_DETAILS',
    TOGGLE_RUNNING = 'TOGGLE_RUNNING',

    // tasks
    ADD_TASK = 'ADD_TASK',
    SET_TASKS = 'SET_TASKS',
    REMOVE_TASK = 'REMOVE_TASK',
    UPDATE_TASK_PROJECT = 'UPDATE_TASK_PROJECT',
    UPDATE_TASK = 'UPDATE_TASK',

    // projects
    ADD_PROJECT = 'ADD_PROJECT',
    SET_PROJECTS = 'SET_PROJECTS',
    REMOVE_PROJECT = 'REMOVE_PROJECT',
    UPDATE_PROJECT = 'UPDATE_PROJECT'
};